import Vue from 'vue'
import Router from 'vue-router'
import VueI18n from 'vue-i18n'
import i18n from '../i18n'
// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Login from '@/views/account/Login'
import Profile from '@/views/account/Profile'
import Loading from '@/views/account/Loading'
import Impersonate from '@/views/account/Impersonate'

// Views Statistics
import ConversionsCountry from '@/views/statistics/conversions/Country.vue'
import ConversionsOffer from '@/views/statistics/conversions/Offer.vue'
import ConversionsPeriod from '@/views/statistics/conversions/Period.vue'
import ConversionsCourier from '@/views/statistics/conversions/Courier.vue'
import ConversionsGraph from '@/views/statistics/conversions/Graph.vue'
import ConversionsBuyout from '@/views/statistics/conversions/Buyout.vue'
import ConversionsFlypost from '@/views/statistics/conversions/Flypost.vue'

import Webmasters from '@/views/statistics/Webmasters.vue'
import WebmastersPayments from '@/views/statistics/webmaster/Payments.vue'
import Source from '@/views/statistics/webmaster/Source.vue'
import Landing from '@/views/statistics/webmaster/Landing.vue'
import Grid from '@/views/statistics/webmaster/Grid.vue'
import ArrivalNewLeads from '../views/statistics/webmaster/ArrivalNewLeads'
import WebAnalysis from '@/views/statistics/webmaster/WebAnalysis'

import OperatorEfficiency from '@/views/statistics/operators/Efficiency.vue'
import OperatorActivity from '@/views/statistics/operators/Activity.vue'
import OperatorOrder from '@/views/statistics/operators/Order.vue'
import OperatorConversion from '@/views/statistics/operators/conversions/Conversion.vue'
import NewOrders from '../views/statistics/operators/conversions/NewOrders'
import NewOrdersWeek from '../views/statistics/operators/conversions/NewOrdersWeek'
import OperatorSchedule from '@/views/statistics/operators/OperatorSchedule.vue'
import ExpectedExpensesKC from '@/views/statistics/operators/ExpectedExpensesKC.vue'
import CallStatistics from '@/views/statistics/operators/CallStatistics'
import OperatorsAnalysis from '../views/statistics/operators/OperatorsAnalysis'
import RingingSms from '../views/statistics/operators/ringing/RingingSms'
import WorkTimingKC from '../views/statistics/operators/WorkTimingKC'
import RingingHolds from '../views/statistics/operators/RingingHolds'
import SentSmsTemplate from '../views/statistics/operators/ringing/SentSmsTemplate'
import CrossSell from '../views/statistics/operators/CrossSell'

import Rentability from '@/views/statistics/offers/Rentability.vue'

import RefundsCancel from '@/views/statistics/refunds/Cancel.vue'
import RefundsReturn from '@/views/statistics/refunds/Return.vue'

import RefundsCancelByMonth from '@/views/statistics/refunds/CancelByMonth.vue'
import RefundsReturnByMonth from '@/views/statistics/refunds/ReturnByMonth.vue'
import CancelOperators from '@/views/statistics/refunds/CancelOperators.vue'

import Product from '@/views/statistics/product/Product.vue'
import ProductCountry from '@/views/statistics/product/ProductCountry.vue'
import ProductTag from '@/views/statistics/product/ProductTag.vue'
import ProductBalance from '@/views/statistics/product/ProductBalance.vue'
import OrdersReceipt from '@/views/statistics/product/Orders-Receipt.vue'

import BuyoutCountry from '@/views/statistics/buyout/Country.vue'
import BuyoutOffer from '@/views/statistics/buyout/Offer.vue'
import BuyoutCouriers from '@/views/statistics/buyout/Couriers.vue'
import BuyoutWeek from '@/views/statistics/buyout/Week.vue'
import BuyoutDays from '@/views/statistics/buyout/Days.vue'
import BuyoutMonth from '@/views/statistics/buyout/Month.vue'
import ChangeLog from '@/views/pages/ChangeLog.vue'
import ChangeVersion from '@/views/pages/ChangeVersion.vue'

Vue.use(Router)

const vm = new Vue({
  i18n
})

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: vm.$t('pages.analytics'),
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: vm.$t('pages.dashboard'),
          component: Dashboard
        },
        {
          path: '/pages/changelog',
          name: vm.$t('pages.changelog'),
          component: ChangeLog
        },
        {
          path: '/pages/versions',
          name: vm.$t('pages.changeversion'),
          component: ChangeVersion
        },
        {
          path: '/statistic/conversions',
          redirect: '/statistic/conversions/country',
          name: vm.$t('pages.conversions'),
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/statistic/conversions/country',
              name: vm.$t('pages.by_country'),
              component: ConversionsCountry
            },
            {
              path: '/statistic/conversions/offers',
              name: vm.$t('pages.by_offers'),
              component: ConversionsOffer
            },
            {
              path: '/statistic/conversions/period',
              name: vm.$t('pages.by_period'),
              component: ConversionsPeriod
            },
            {
              path: '/statistic/conversions/courier',
              name: vm.$t('pages.by_couriers'),
              component: ConversionsCourier
            },
            {
              path: '/statistic/conversions/graph',
              name: vm.$t('pages.by_graph'),
              component: ConversionsGraph
            },
            {
              path: '/statistic/conversions/buyout',
              name: vm.$t('pages.by_pieces'),
              component: ConversionsBuyout
            },
            {
              path: '/statistic/conversions/flypost',
              name: vm.$t('pages.buyouts_flypost'),
              component: ConversionsFlypost
            }
          ]
        },
        {
          path: '/statistic/webmasters',
          name: vm.$t('pages.webmasters'),
          component: Webmasters
        },
        {
          path: '/statistic/webmasters/payments',
          name: vm.$t('pages.webmaster_individual_rates'),
          component: WebmastersPayments
        },
        {
          path: '/statistic/webmasters/source',
          name: vm.$t('pages.source_statistic'),
          component: Source
        },
        {
          path: '/statistic/webmasters/landing',
          name: vm.$t('pages.landing_statistic'),
          component: Landing
        },
        {
          path: '/statistic/webmasters/grid',
          name: vm.$t('pages.grid_statistic'),
          component: Grid
        },
        {
          path: '/statistic/webmasters/arrival_new_leads',
          name: vm.$t('pages.arrival_new_leads'),
          component: ArrivalNewLeads
        },
        {
          path: '/statistic/webmasters/analysis',
          name: vm.$t('pages.web_analysis'),
          component: WebAnalysis
        },
        {
          path: '/statistic/refunds',
          redirect: '/statistic/refunds/return_by_month',
          name: vm.$t('pages.refunds'),
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/statistic/refunds/return',
              name: vm.$t('pages.ref_return'),
              component: RefundsReturn
            },
            {
              path: '/statistic/refunds/cancel',
              name: vm.$t('pages.ref_cancel'),
              component: RefundsCancel
            },
            {
              path: '/statistic/refunds/cancel_by_month',
              name: vm.$t('pages.ref_cancel_by_month'),
              component: RefundsCancelByMonth
            },
            {
              path: '/statistic/refunds/return_by_month',
              name: vm.$t('pages.ref_return_by_month'),
              component: RefundsReturnByMonth
            },
            {
              path: '/statistic/refunds/cancel_operators',
              name: vm.$t('pages.ref_cancel_operators'),
              component: CancelOperators
            }
          ]
        },
        {
          path: '/statistic/buyout',
          redirect: '/statistic/buyout/country',
          name: vm.$t('pages.buyout'),
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/statistic/buyout/country',
              name: 'by_country',
              component: BuyoutCountry
            },
            {
              path: '/statistic/buyout/offers',
              name: 'by_offers',
              component: BuyoutOffer
            },
            {
              path: '/statistic/buyout/couriers',
              name: 'by_couriers',
              component: BuyoutCouriers
            },
            {
              path: '/statistic/buyout/weeks',
              name: vm.$t('pages.by_weeks'),
              component: BuyoutWeek
            },
            {
              path: '/statistic/buyout/days',
              name: vm.$t('pages.by_days'),
              component: BuyoutDays
            },
            {
              path: '/statistic/buyout/month',
              name: vm.$t('pages.by_month'),
              component: BuyoutMonth
            }
          ]
        },
        {
          path: '/statistic/offer',
          redirect: '/statistic/offer',
          name: vm.$t('pages.offer'),
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/statistic/offer',
              name: vm.$t('pages.offer_rent'),
              component: Rentability
            }
          ]
        },
        {
          path: '/statistic/operators',
          redirect: '/statistic/operators/efficiency',
          name: vm.$t('pages.operators'),
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/statistic/operators/efficiency',
              name: vm.$t('pages.efficiency'),
              component: OperatorEfficiency
            },
            {
              path: '/statistic/operators/activity',
              name: vm.$t('pages.activity'),
              component: OperatorActivity
            },
            {
              path: '/statistic/operators/order',
              name: vm.$t('pages.order'),
              component: OperatorOrder
            },
            {
              path: '/statistic/operators/conversions/conversion',
              name: 'order',
              component: OperatorConversion
            },
            {
              path: '/statistic/operators/conversions/new_orders',
              name: vm.$t('pages.new_orders'),
              component: NewOrders
            },
            {
              path: '/statistic/operators/conversions/new_orders_week',
              name: vm.$t('pages.new_orders_week'),
              component: NewOrdersWeek
            },
            {
              path: '/statistic/operators/schedule',
              name: vm.$t('pages.approved_during_the_day'),
              component: OperatorSchedule
            },
            {
              path: '/statistic/operators/expenses_kc',
              name: vm.$t('pages.expenses_by_kc'),
              component: ExpectedExpensesKC
            },
            {
              path: '/statistic/operators/timing_kc',
              name: vm.$t('pages.timing_kc'),
              component: WorkTimingKC
            },
            {
              path: '/statistic/operators/ringing_sms',
              name: vm.$t('pages.ringing_sms'),
              component: RingingSms
            },
            {
              path: '/statistic/operators/sent_sms_template',
              name: vm.$t('pages.sent_sms_template'),
              component: SentSmsTemplate
            },
            {
              path: '/statistic/operators/call_statistics',
              name: vm.$t('pages.call_statistics'),
              component: CallStatistics
            },
            {
              path: '/statistic/operators/operators_analysis',
              name: vm.$t('pages.operators_analysis'),
              component: OperatorsAnalysis
            },
            {
              path: '/statistic/operators/ringing_holds',
              name: vm.$t('pages.ringing_holds'),
              component: RingingHolds
            },
            {
              path: '/statistic/operators/cross_sell',
              name: vm.$t('pages.cross_sell'),
              component: CrossSell
            }
          ]
        },
        {
          path: '/statistic/product',
          redirect: '/statistic/product/offer',
          name: vm.$t('pages.product'),
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/statistic/product/offer',
              name: vm.$t('pages.by_offers'),
              component: Product
            },
            {
              path: '/statistic/product/country',
              name: vm.$t('pages.by_country'),
              component: ProductCountry
            },
            {
              path: '/statistic/product/tag',
              name: vm.$t('pages.by_category_product'),
              component: ProductTag
            },
            {
              path: '/statistic/product/balance',
              name: vm.$t('pages.by_balance_currency'),
              component: ProductBalance
            },
            {
              path: '/statistic/product/orders_receipt',
              name: vm.$t('pages.orders_receipt'),
              component: OrdersReceipt
            }
          ]
        }
      ]
    },
    {
      path: '/404',
      name: '404 Error',
      component: Page404
    },
    {
      path: '/impersonate',
      name: 'Impersonate',
      component: Impersonate
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/loading',
      name: 'Loading',
      component: Loading
    },
    {
      path: '/account/',
      redirect: '/account/profile',
      name: vm.$t('auth.account'),
      component: Full,
      children: [
        {
          path: 'profile',
          name: vm.$t('auth.profile'),
          component: Profile
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js